import { sessionManager } from 'vue-infra';
import { PRIVILEGES } from '@/const/privileges';
import { FEATURES } from '@/const/features';

const hasConversationAssistPermission = () => {
  const conversationBuilderEnabled = sessionManager.getFeaturePropertyState(
    FEATURES.AUTOMATION_CONVERSATION_BULDER,
  );
  return (
    conversationBuilderEnabled &&
    (sessionManager.hasPrivilege(PRIVILEGES.CB_VIEW_BOTS) ||
      sessionManager.hasPrivilege(PRIVILEGES.CB_VIEW_KNOWLEDGE_BASE) ||
      // old roles - backwards compatibility
      sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_ADMIN) ||
      sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_BOTS) ||
      sessionManager.hasPrivilege(PRIVILEGES.BOT_BUILDER_CONTENT_USER) ||
      // LPA
      sessionManager.isLPA())
  );
};

export default hasConversationAssistPermission;
